module.exports = __webpack_public_path__ + "media/images/servall-a3bf01ee65842835b67a158d9029a5be.png";